/* eslint-disable no-unused-vars */
import React from "react";

import { FormattedDate, FormattedTime } from "react-intl";

import Typography from "@material-ui/core/Typography";

import SunCalc from "suncalc";

interface SunriseSunsetProps {
  // nodes: any[];
  data: any; // any[];
  widgetStatic?: boolean;
  widgetTitle?: string;
}

/*
 * https://materialdesignicons.com/
 * weather-sunset-up weather-sunset-down
 * weather-sunset-down + weather-sunset-down mdi-flip-v
 */
const SunriseSunset = (props: SunriseSunsetProps) => {
  const {
    // nodes,
    data,
    // widgetStatic
  } = props;

  const { latitude, longitude } = data;
  const times = SunCalc.getTimes(new Date(), latitude, longitude);

  // TODO display station name

  return (
    <div>
      <Typography variant="subtitle2">
        Sunrise:
        <FormattedDate
          value={times.sunrise}
          year="numeric"
          month="2-digit"
          day="2-digit"
        />
        &nbsp;
        <FormattedTime value={times.sunrise} />
      </Typography>
      <Typography variant="subtitle2">
        Sunset:
        <FormattedDate
          value={times.sunset}
          year="numeric"
          month="2-digit"
          day="2-digit"
        />
        &nbsp;
        <FormattedTime value={times.sunset} />
      </Typography>
    </div>
  );
};

export default SunriseSunset;
